import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { ProductCategory, ProductCategoryService } from 'src/app/core/product-category.service';
import { ProductCategoryUpdateCategoryDialogComponent } from '../product-category-update-category-dialog/product-category-update-category-dialog.component';
import { ProductCategoryDeleteDialogComponent } from '../product-category-delete-dialog/product-category-delete-dialog.component';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { PRODUCT_CATEGORY_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { NavigationService } from 'src/app/core/navigation.service';
import { ProductCategoryUpdateStepsDialogComponent } from '../product-category-update-steps-dialog/product-category-update-steps-dialog.component';

@Component({
  selector: 'app-product-category-data-table',
  templateUrl: './product-category-data-table.component.html',
  styleUrls: ['./product-category-data-table.component.scss'],
})
export class ProductCategoryDataTableComponent {
  @Input() product_categories: ProductCategory[] = [];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();

  displayed_columns: string[] = PRODUCT_CATEGORY_TABLE_COLUMNS;

  constructor(
    private dialog_service: DialogService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  onEditClick(category: ProductCategory): void {
    this.dialog_service
      .openDialog(ProductCategoryUpdateCategoryDialogComponent, { category })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onStepsEditClick(category: ProductCategory): void {
    this.dialog_service
      .openDialog(ProductCategoryUpdateStepsDialogComponent, { category })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onDeleteClick(category: ProductCategory): void {
    this.dialog_service
      .openDialog(ProductCategoryDeleteDialogComponent, { category })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  onDetailsClick(product_category: ProductCategory): void {
    this.navigation_service.toProductSubCategory(product_category.product_category_id as string);
  }
}
